import {extend, localize} from 'vee-validate'

// Rules.
import * as rules from 'vee-validate/dist/rules'
Object.keys(rules).forEach(rule => {
    extend(rule, rules[rule])
})

// Custom rules.
import * as customRules from './rules'
Object.keys(customRules).forEach(validation => {
    extend(validation, customRules[validation])
})

// Lang.
import pt_BR from '@/plugins/vee-validate/locale/pt_BR.json'
localize('pt_BR', pt_BR)